import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import Schools from 'features/schools';
import { ActiveSchoolList } from 'features/shared/Onbording';

const Page = () => (
  <MainLayout>
    <ActiveSchoolList />
    <Schools />
  </MainLayout>
);

export default Page;
